import type { BaseBigNumber } from '../abstracts';

export interface IRootBlockInfo {
  start: string;
  end: string;
  headerBlockNumber: BaseBigNumber;
}
